// eslint-disable-next-line import/named
import { isCurrentUserOutboundUser } from 'utils/helper'
import { FileExchangeSourceEnum, FileExchangeStatus, FileExchangeTypeEnum } from '../types/FileShareEnums'
import { getFileList } from './fileShareApi'

export const createFileShareServerSideDataSource = () => {
  return {
    getRows: (params: any) => {
      params.api.showLoadingOverlay()
      params.api.showNoRowsOverlay()
      fetchFilesWithBuiltQuery(params)
      return params
    },
  }
}

export const fetchFilesWithBuiltQuery = (params: any) => {
  const isOutboundUser = isCurrentUserOutboundUser()
  const fileSource = isOutboundUser ? FileExchangeSourceEnum.OutboundAi : FileExchangeSourceEnum.Customer
  const fileType = FileExchangeTypeEnum.Onboarding
  const fileStatus = FileExchangeStatus.Uploaded
  getFileList(fileSource, fileType, fileStatus)
    .then((response) => {
      const data = response

      /**
       * If no data available then we need to show 'No data available Message'
       */
      const noDataAvailable: boolean = (data.data.resultCount === 0 && data.data.fileExchangeList.length <= 0) ?? true
      if (noDataAvailable) {
        params.api.showNoRowsOverlay()
      } else {
        params.api.hideOverlay()
      }

      params.success({ rowData: data.data.fileExchangeList, rowCount: data.data.resultCount })
    })
    .catch((error) => {
      params.api.hideOverlay()
      console.log(error)
    })
}
